<template>
  <DxPopup title="New Cabinet"
           v-model:visible="popupVisible"
           :show-title="true"
           :show-close-button="true"
           :hide-on-outside-click="true"
           :width="500"
           height="auto"
           container=".cabinet-content-container"
           @showing="onShowing"
  >
    <DxPosition at="center" my="center" collision="fit"/>
    <div class="settings-container settings-card">
      <DxForm v-model:form-data="cabinetData" :show-colon-after-label="false">
        <DxSimpleItem data-field="name" editor-type="dxTextBox" :editor-options="{ maxLength: 32 }">
          <DxRequiredRule message="Name is required"/>
          <DxStringLengthRule :min="2" message="Name must have at least 2 characters"/>
        </DxSimpleItem>

        <DxSimpleItem data-field="description" editor-type="dxTextArea" :editor-options="{ maxLength: 200 }"/>

        <DxSimpleItem v-if="isAdmin"
                      data-field="source_cabinet_id"
                      editor-type="dxSelectBox"
                      :label="{ text: 'Copy settings from' }"
                      :editor-options="sourceCabinetEditorOptions"
        />
      </DxForm>

      <div v-if="isAdmin && cabinetData.source_cabinet_id" class="copy-settings-message">
        The following will be copied: metadata columns, lookup options, and member access.
      </div>

      <DxButton class="save-button"
                text="Save"
                type="action"
                width="30%"
                @click="addCabinet"
      />
    </div>
  </DxPopup>
</template>

<script setup>
  import { DxPopup, DxPosition } from "devextreme-vue/popup";
  import { DxForm, DxSimpleItem, DxRequiredRule, DxStringLengthRule } from "devextreme-vue/form";
  import { DxButton } from "devextreme-vue";
  import { computed, ref } from "vue";
  import { storeToRefs } from "pinia";
  import { useCabinetsPageStore } from "@/stores/cabinetsPageStore.js";
  import { useUserStore } from "@/stores/userStore.js";
  import { randomColor } from "@/js-modules/colorPalettes.js";

  const cabinetsPageStore = useCabinetsPageStore()
  const { createCabinet, getAllCabinets } = cabinetsPageStore
  const { allCabinets } = storeToRefs(cabinetsPageStore)

  const userStore = useUserStore()
  const { isAdmin } = storeToRefs(userStore)

  const emit = defineEmits(['closePopup'])

  const popupVisible = ref(false)
  const cabinetData = ref({})

  const sourceCabinetEditorOptions = computed(() => ({
    items: allCabinets.value,
    displayExpr: 'name',
    valueExpr: 'cabinet_id',
    searchEnabled: true,
    showClearButton: true,
    placeholder: 'None (use defaults)'
  }))

  const addCabinet = () => {
    const { source_cabinet_id, ...cabinetFields } = cabinetData.value
    const newCabinetData = {
      cabinet: {
        color: randomColor('muted'),
        ...cabinetFields
      }
    }

    if (isAdmin.value && source_cabinet_id) {
      newCabinetData.cabinet.source_cabinet_id = source_cabinet_id
    }

    createCabinet(newCabinetData)
    emit('closePopup')
  }

  const onShowing = () => {
    cabinetData.value = {}
    if (isAdmin.value) {
      getAllCabinets()
    }
  }
</script>

<style scoped lang="scss">
  .settings-container {
    background-color: $white-light;
  }

  .copy-settings-message {
    margin: 0.75rem 0 1rem;
    padding: 0.85rem 1rem;
    background: $blue-100;
    color: $la-new-dark-gray;
    font-size: 0.875rem;
    line-height: 1.4;
  }

  .save-button {
    margin-top: 0.5rem;
  }
</style>
